import { m8API } from 'services/production/m8';
import { normalizeM8PartnerDTO } from 'services/production/utils/normalizeM8PartnerDTO';
import { normalizePartnerProfileFormValues } from 'services/production/utils/normalizePartnerProfileFormValues';
import { PartnerProfileChangeFormSubmitService } from 'types/services';
import { validatePartnerProfileAvatarCroppedFile } from 'utils/validatePartnerProfileAvatarFile';

export const submitPartnerProfileChangeForm: PartnerProfileChangeFormSubmitService = async (
  partnerId,
  formValues
) => {
  let m8PartnerDTO, avatarURL;

  if (partnerId) {
    if (formValues.avatar) {
      const file = await formValues.avatar.readEditedFile();

      await validatePartnerProfileAvatarCroppedFile(file);

      await m8API.admin.setPartnerAvatar({
        idPartner: partnerId,
        image: file,
        mimeType: file.type,
      });
    }

    m8PartnerDTO = await m8API.admin.updatePartnerInfo({
      idPartner: partnerId,
      partnerInfo: normalizePartnerProfileFormValues(
        formValues
      ).toM8PartnerInfo(),
    });

    avatarURL = await m8API.admin.getPartnerAvatarURL({ idPartner: partnerId });
  } else {
    if (formValues.avatar) {
      const file = await formValues.avatar.readEditedFile();

      await validatePartnerProfileAvatarCroppedFile(file);

      await m8API.partner.setPartnerAvatar({
        image: file,
        mimeType: file.type,
      });
    }

    m8PartnerDTO = await m8API.partner.updatePartnerInfo(
      normalizePartnerProfileFormValues(formValues).toM8PartnerInfo()
    );

    avatarURL = await m8API.partner.getPartnerAvatarURL();
  }

  return normalizeM8PartnerDTO(m8PartnerDTO).toPartnerProfile(
    avatarURL || undefined
  );
};
